import { createSlice } from '@reduxjs/toolkit'

import { setLoading, setSuccess, unSet } from 'api/remoteData'
import { dismissReminder, getReminders } from 'services/reminder'
import { LeadActivityReminder as LeadActivityReminderData } from 'services/types/reminder'
import { LeadActivityReminder } from 'store/types/reminder'
import { FETCHING_STATUS } from 'utils/constants'

import { ReminderState } from './types'

const { fail, success } = FETCHING_STATUS

const initialState: ReminderState = {
  reminders: unSet(),
}

const { actions, reducer } = createSlice({
  initialState,
  name: 'reminders',
  reducers: {
    addReminder: (state, { payload }) => {
      const existing = state.reminders.status === success ? state.reminders.data : []

      return {
        ...state,
        reminders: setSuccess([mapReminder(payload), ...existing]),
      }
    },
    clear: () => initialState,
    removeReminder: (state, { payload }) => {
      if (
        state.reminders.status !== success ||
        !state.reminders.data.find((i) => i.reminderId === payload.reminder_id)
      ) {
        return state
      }

      return {
        ...state,
        reminders: setSuccess(state.reminders.data.filter((i) => i.reminderId !== payload.reminder_id)),
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReminders.pending, (state) => ({
        ...state,
        reminders: setLoading(),
      }))
      .addCase(getReminders.fulfilled, (state, { payload }) => {
        if (payload.status === fail) {
          return { ...state, reminders: payload }
        }

        return {
          ...state,
          reminders: setSuccess(payload.data.data?.map((i) => mapReminder(i)) || []),
        }
      })

    builder.addCase(dismissReminder.fulfilled, (state, { meta, payload }) => {
      if (state.reminders.status !== success || payload.status === fail) {
        meta.arg.onFail()
        return state
      }

      meta.arg.onSuccess()

      return {
        ...state,
        reminders: setSuccess(state.reminders.data.filter((i) => !meta.arg.reminder_id.includes(i.reminderId))),
      }
    })
  },
})

const mapReminder: (data: LeadActivityReminderData) => LeadActivityReminder = (data) => ({
  id: data.id,
  leadId: data.lead_id,
  reminderId: data.reminder_id,
  startDate: data.start_date,
  title: data.title,
  type: data.type,
})

export default reducer
export { actions }
